import React from 'react'
import { Helmet } from 'react-helmet-async';

import { apparelCategoryLargeDefaultImage, apparelCategoryMediumDefaultImage, apparelCategorySmallDefaultImage, foodCategoryLargeDefaultImage, foodCategoryMediumDefaultImage, foodCategorySmallDefaultImage, getAllProducts, useSelector } from "../../../imports/generalImport";
import { Box, Container, Stack, Typography } from '../../../imports/muiImport';

import { SliderComponent } from "../../../components/SliderComponent";
import MobileHotDeals from '../../mobileComponents/mobileProductCard/MobileHotDeals';
import MobileHomeSearch from '../../mobileComponents/mobileHomeSearch/MobileHomeSearch';
import MobileListVoucher from '../../mobileComponents/mobileProductCard/MobileListVoucher';
import MobileHomeCategory from '../../mobileComponents/mobileHomeCategory/MobileHomeCategory';
import MobileFeatureComponent from '../../mobileComponents/mobileFeatureComponent/MobileFeatureComponent';
import MobileThreeGridComponent from '../../mobileComponents/mobileProductCard/MobileThreeGridComponent';
import MobileProductSection from '../../mobileComponents/mobileProductCard/MobileProductSection';
import MobileSectionTitle from '../../mobileComponents/mobileProductCard/MobileSectionTitle';


const foodDefaultImages = {
    largeImage1: foodCategoryLargeDefaultImage,
    mediumImage1: foodCategoryMediumDefaultImage,
    mediumImage2: foodCategoryMediumDefaultImage,
    smallImage1: foodCategorySmallDefaultImage,
    smallImage2: foodCategorySmallDefaultImage,
}

const apparelDefaultImages = {
    largeImage1: apparelCategoryLargeDefaultImage,
    mediumImage1: apparelCategoryMediumDefaultImage,
    mediumImage2: apparelCategoryMediumDefaultImage,
    smallImage1: apparelCategorySmallDefaultImage,
    smallImage2: apparelCategorySmallDefaultImage,
}

function MobileHomePage() {
    const [productLoading, setProductLoading] = React.useState(false);
    const [productsData, setProductsData] = React.useState({
        pagination: null,
        products: [],
    });

    const fetchProductsData = async () => {
        setProductLoading(() => true);
        try {
            const response = await getAllProducts({});
            if (response?.status) {
                setProductsData({
                    pagination: response?.data?.pagination,
                    products: response?.data?.products,
                });
            }
        } catch (error) {
            console.error('Error fetching products data:', error);
        } finally {
            setProductLoading(() => false);
        }
    };

    React.useEffect(() => {
        fetchProductsData();
    }, []);

    return (
        <>
            <Helmet>
                <title>Gift Cards: Discounted eGift Cards for 250+ Brands in India</title>
                <meta name="description" content="99Gift offers a wide variety of discounted gift cards for over 250 brands in India, including Apparels, eCommerce, Entertainment, Travels, Food, Entertainment, Grocery, Mobile, Footwear Etc. You can also find E-Gift cards for personal and commercial use" />
                <meta property="og:title" content="99Gift - 200+ Brands Discount Gift Vouchers Online" />
                <meta property="og:description" content="99Gift offers a wide variety of discounted gift cards for over 250 brands in India, including Apparels, eCommerce, Entertainment, Travels, Food, Entertainment, Grocery, Mobile, Footwear Etc. You can also find E-Gift cards for personal and commercial use" />
            </Helmet>

            <Container disableGutters>
                <Box component={"div"} sx={{ px: 1, }}>
                    <MobileHomeSearch />
                    <Box component={"div"} sx={{ mt: 2.5 }}>
                        <SliderComponent dots={true} height={190} />
                    </Box>
                </Box>

                <MobileHomeCategory />
                <Box pb={6}>
                    <Stack
                        sx={{
                            pt: 3,
                            px: 2,
                            mb: 2,
                        }}
                    >
                        <MobileSectionTitle
                            sectionTitle={"All Gift Vouchers"}
                            buttonText={null}
                            customBtnHandler={null}
                        />
                    </Stack>

                    <MobileProductSection
                        products={productsData?.["products"]?.slice(0, 16)}
                    />
                </Box>
            </Container>
        </>
    )
}

export default MobileHomePage;
